import { Children, useState } from "react";
import { AddIcon, ServiceIcon } from "allIcons";
import {
  BodyContainer,
  HeaderContainer,
  InputField,
  ListCard,
  ListIconWrapper,
  MainButton,
  PrimaryHeading,
  RightMainContainer,
} from "commonUI";
import { t } from "i18next";
import { ModulePrefixes } from "enums";

export default function Services() {
  const [services, setServices] = useState([
    "[Service Title]",
    "[Service Title]",
    "[Service Title]",
    "[Service Title]",
  ]);
  return (
    <>
      <RightMainContainer>
        <HeaderContainer>
          <PrimaryHeading>Services</PrimaryHeading>
          <MainButton>
            <AddIcon />
            Add
          </MainButton>
        </HeaderContainer>
        <BodyContainer>
          <InputField placeholder={t("input.search.placeholder")} searchIcon={true} filter={true} />
          {Children.toArray(
            services.map((task, index) => {
              return (
                <ListCard
                  data={task}
                  duplicate={true}
                  secondaryData="[Price/Frequency]"
                  edit={true}
                  link={`/${ModulePrefixes.TEMPLATE_LIBRARY}/services/${index}`}
                  strictLink={true}
                  onDuplicate={(data) => {
                    setServices(() => [...services, `Copy of ${data}`]);
                  }}
                  onDelete={() => {
                    setServices(() =>
                      services.filter((item, i) => i !== index)
                    );
                  }}
                  icon={
                    <ListIconWrapper>
                      <ServiceIcon fill="white" />
                    </ListIconWrapper>
                  }
                  deleteTitle={t("libraryTemplate.delete.title")}
                  deleteButtonText="Confirm Delete"
                  deleteMessage={t("libraryTemplate.delete.message")}
                />
              );
            })
          )}
        </BodyContainer>
      </RightMainContainer>
    </>
  );
}
